import React from 'react';
import MasterExportContainer from 'common/entity/generic/MasterExportContainer';

class MasterExportContainerWithDocuments extends React.PureComponent {
    getAdditionalColumns = columnAccessors => {
        const { columns, getAdditionalColumns } = this.props;
        let updatedColumnAccessors = [...columnAccessors];
        if (getAdditionalColumns) {
            updatedColumnAccessors = getAdditionalColumns(
                updatedColumnAccessors
            );
        }
        const documentColumns = columns.filter(
            column => column.property === 'documents'
        );
        documentColumns.forEach((column, index) => {
            const indexToRemove = columns.findIndex(
                col => col.id === column.id
            );
            updatedColumnAccessors.splice(indexToRemove - index, 1);
        });
        updatedColumnAccessors.push('documents');
        return updatedColumnAccessors;
    };

    render() {
        return (
            <MasterExportContainer
                {...this.props}
                getAdditionalColumns={this.getAdditionalColumns}
            />
        );
    }
}

export default MasterExportContainerWithDocuments;
